<template>
  <div>
    <div class="display-flex top-bar">
      <div class="bread-crumbs">
        <bread-crumbs :bread="breadCrambs" />
      </div>
      <div v-if="filters !== null && filters.length" class="filter">
        <span @click="showFilter" class="lye-button filter-button"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             width="971.986px" height="971.986px" viewBox="0 0 971.986 971.986" style="enable-background:new 0 0 971.986 971.986;"
             xml:space="preserve">
<g>
	<path d="M370.216,459.3c10.2,11.1,15.8,25.6,15.8,40.6v442c0,26.601,32.1,40.101,51.1,21.4l123.3-141.3
		c16.5-19.8,25.6-29.601,25.6-49.2V500c0-15,5.7-29.5,15.8-40.601L955.615,75.5c26.5-28.8,6.101-75.5-33.1-75.5h-873
		c-39.2,0-59.7,46.6-33.1,75.5L370.216,459.3z"/>
</g>
</svg> Фильтр </span>

      </div>
    </div>
    <product-filter v-if="filters !== null" @setSelected="setSelected" @filterProducts="filterProducts" ref="filter" :filters="filters" :filterAvailable="filterAvailable"/>

    <Products :products="products"/>
  </div>
</template>

<script>

import Products from "@/components/Products";
import axios from "axios";
import BreadCrumbs from "@/components/Product/BreadCrumbs";
import ProductFilter from "@/components/Product/ProductFilter";
export default {
  name: 'Category',
  props: ['id'],
  data() {
    return {
      products: null,
      origProducts: null,
      breadCrambs: [
        {
          name: 'Каталог',
          path: '/',
        },
      ],
      filters: null,
      selected: [],
      filterAvailable: []
    }
  },
  components: {
    ProductFilter,
    BreadCrumbs,
    Products
  },
  // watch: {
  //   selected(){
  //
  //   }
  // },
  methods: {

    setAvailabelFilter() {
      this.products.forEach( p => {
        p.filters.forEach(f => {
          let filerAvailableItem = this.filterAvailable.find(item => item.group_id === f.group_id);
          if (filerAvailableItem) {
            f.values.forEach( v => {
              if (!filerAvailableItem.values.find(sv => sv == v)) {
                filerAvailableItem.values.push(v)
              }
            })
          } else {
            this.filterAvailable.push(f)
          }
        })
      })
    },
    setSelected(sel) {
      this.selected = sel
    },
    filterProducts() {
      if (this.selected.length == 0) {
        return this.products = this.origProducts
      }

      this.products = this.origProducts.filter( p => {
        let ge = false
        p.filters.forEach( f => {
          let item = this.selected.filter( s => s.group_id == f.group_id && s.value.id == f.values[0])
          if (item.length !== 0) {
            ge = true
          }
        })
        if (ge) {
          return p
        }
      })
      this.setAvailabelFilter()
    },
    getProducts () {
      axios.get(process.env.VUE_APP_API_URL, { params: {
          category: 'get',
          id: this.id
        }})
          .then((response) => {
            this.products = response.data
            this.breadCrambs.push({name: this.products[0].categoryName})
            this.origProducts = Object.assign([], this.products);
          })
    },
    getFilters () {
      axios.get(process.env.VUE_APP_API_URL, { params: {
          filters: 'getCategoryFilter',
          category_id: this.id
        }})
          .then((response) => {
            this.filters = response.data
          })
    },
    showFilter() {
      this.$refs.filter.showFilter();
    },
  },
  mounted() {
    this.getProducts ()
    this.getFilters ()
  }
}
</script>

<style scoped>
.top-bar {
  align-items: center;
}
.bread-crumbs {
  width: 80%;
}
.filter {
  width: 20%;
  text-align: right;
}
.filter-button {
  display: inline-flex;
  align-items: center;
}

.filter-button svg{
  width: 13px;
  height: 13px;
  margin: 0 10px 0 0;
}
</style>
